import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Jätka ostuga

  <span style="color:#85c1dc;">**FI:**</span>
  Jatka ostoksia

  <span style="color:#85c1dc;">**RU:**</span>
  Продолжить покупки
*/
/* @__NO_SIDE_EFFECTS__ */
const m155 = msg(
  mf`Jätka ostuga`,
  mf`Jatka ostoksia`,
  mf`Продолжить покупки`,
)

export { m155 as 'w.basket.continue_mobile' }